export function isIOS() {
    const ua = navigator.userAgent || ''
    const iOSLike = /iPad|iPhone|iPod/.test(ua)
    // iPadOS 13+ reports as Mac; touch points > 1 is the common workaround
    const iPadOS13Up = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
    return iOSLike || iPadOS13Up
}

export function isOtherIOSBrowser(ua) {
    return /(CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|YaBrowser|Vivaldi)/i.test(ua)
}

export function isInAppWebView(ua) {
    // Many webviews omit 'Version/' but still have 'Safari'
    // Also match popular in-app UAs explicitly
    if (/(FBAN|FBAV|Instagram|Line|WeChat|Twitter|GSA|TikTok|Snapchat|Pinterest)/i.test(ua)) return true

    // Heuristic: iOS WebViews often lack the "Version/x.y" token
    const hasSafari = /\bSafari\b/i.test(ua)
    const hasVersion = /\bVersion\/[\d.]+/i.test(ua)
    return hasSafari && !hasVersion
}

export function isIOSSafari() {
    if (!isIOS()) return false
    const ua = navigator.userAgent || ''

    // Must have both Version/x.y and Safari, and not be another iOS browser
    const hasSafari = /\bSafari\b/i.test(ua)
    const hasVersion = /\bVersion\/[\d.]+/i.test(ua)

    if (!hasSafari || !hasVersion) return false
    if (isOtherIOSBrowser(ua)) return false
    if (isInAppWebView(ua)) return false

    // Extra guard: Apple vendor string is typical for Safari
    const appleVendor = navigator.vendor === 'Apple Computer, Inc.'
    return appleVendor || true // allow if vendor is missing on some builds
}
